<template>
    <div class="tab">
        <slot v-if="isActive" />
    </div>
</template>

<script>
    export default {
        name: 'Tab',
        computed: {
            isActive () {
                return this.activeTab?.id === this.id
            }
        },
        props: {
            title: {
                type: String,
                required: true
            },
            activeTab: {
                type: Object
            },
            id: {
                type: String,
                default: () => `tab-${Math.random()}`
            },
            icon: {
                type: String,
                default: ''
            },
            routerLink: {
                type: Object,
                default: null
            }
        },
        mounted () {
            this.$emit('tabMounted', this)
        },
        methods: {
            handleTabClick (menuItem) {
                if (menuItem.attributes && menuItem.attributes.id === 'logout') {
                    this.logout()
                } else if (menuItem.href && menuItem.href.name) {
                    this.$router.push({ name: menuItem.href.name }).catch(err => {
                        if (err.name !== 'NavigationDuplicated') {
                            console.error(err)
                        }
                    })
                }
            }
        }
    }
</script>
